import script from "./RightMenuMap.vue?vue&type=script&setup=true&lang=js"
export * from "./RightMenuMap.vue?vue&type=script&setup=true&lang=js"

import "./RightMenuMap.vue?vue&type=style&index=0&id=6926b940&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6926b940"]])

export default __exports__